export const REQUEST_BRANDS = "REQUEST_BRANDS";
export const RECEIVE_BRANDS = "RECEIVE_BRANDS";
